import { render, staticRenderFns } from "./ClaimSubmitted.vue?vue&type=template&id=d1750e46"
import script from "./ClaimSubmitted.vue?vue&type=script&lang=js"
export * from "./ClaimSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports